import "./ProfileOrder.scss";
import React, { useState, useEffect } from "react";
import InsLoader from "../../../../components/InsLoader/InsLoader";
import { getUserOrder } from "../../../../api/account";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import OrderItem from "../../../../components/Profile/OrderItem";
import images from "../../../../ressources/images";

const ProfileOrder = (props) => {
  const [loader, setLoader] = useState(true);
  const [order, setOrder] = useState({});
  const orderNbr = props.match.params.id;
  const { t } = props;

  useEffect(() => {
    const getOrder = () => {
      getUserOrder(orderNbr).then((order) => {
        setOrder(order);
        setLoader(false);
      });
    };
    getOrder();
  }, [orderNbr]);

  return (
    <div className="order_page">
      <div className="header">
        <Link
          className="back_link"
          to={{
            pathname: "/profile/orders",
            state: { transitionName: "slide_out" },
          }}
        ></Link>
        {t("order")} N° {orderNbr}
      </div>

      <div className="order_container default-layout--min-height">
        {loader ? (
          <InsLoader />
        ) : (
          <>
            <div className="order_wrapper">
              <div className="order_summary">
                {t("order_summary")}
              </div>
              <div className="order-status">
                <span
                  className="order-status__label"
                >
                  {t("order_status")}
                </span>
                <span>:</span>
                <span className="order-status__value">
                  {t(order.status === "confirmed" ? "confirmed" : "refunded")}
                </span>
              </div>
              <div className="tracking-info">
                <span
                  className="tracking-info__label"
                >
                  {t("tracking_url")}
                </span>
                <span>:</span>
                <span className="tracking-info__value">
                  {order.status === "refunded" ? (
                    <span className="empty_url">-</span>
                  ) : (
                    <>
                      {order.trackingUrl ? (
                        <a
                          href={order.trackingUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {order.trackingUrl}
                        </a>
                      ) : (
                        <span className="no_trackingurl">{t("No_Tracking_Number_Available")}</span>
                      )}
                    </>
                  )}
                </span>
              </div>
              {order.elements.products.map((product) => (
                <OrderItem
                  key={product.ean}
                  brand={product.brand}
                  name={product.name}
                  points={product.unitCost}
                  picture={
                    product.picture
                      ? product.picture.name.name_333
                      : images.we_are_lol_black
                  }
                  quantity={product.quantity}
                />
              ))}
            </div>

            <div className="bottom_content">
              <div className="cart_total">
                {t("total")} : {order.elements.totalCost}{" "}
                {t("points")}
              </div>

              <div className="delivery_address">
                <div className="title">{t("my_delivery_address")}</div>
                <div className="delivery_address_container">
                  <div className="delivery_infos">
                    <div className="name">
                      {order.address.firstname} {order.address.lastname}
                    </div>
                    <div className="address">
                      {order.address.address} -{" "}
                      {order.address.postal_code + " " + order.address.city}
                      <div className="additional">
                        {order.address.address_2 ? order.address.address_2 : ""}
                      </div>
                      <div className="phone_field">
                        {order.address?.phone ?? ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(ProfileOrder);
